export class CenterAlertApplication {

    private appInternalId: string;
    private appName: string;

    constructor(appInternalId?: string, appName?: string) {
        this.appInternalId = appInternalId;
        this.appName = appName;
    }

    public get AppInternalId() {
        return this.appInternalId;
    }
    public get AppName() {
        return this.appName;
    }
    public set AppInternalId(appInternalId) {
        this.appInternalId = appInternalId;
    }
    public set AppName(appName) {
        this.appName = appName;
    }
}

